"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AdminLoginInfoEdit_1 = require("./AdminLoginInfoEdit");
exports.default = AdminLoginInfoEdit_1.AdminLoginInfoEdit;
